import keyBy from 'lodash.keyby';
// Local Constants
import {
    SPRAY_EVENTS_FOR_SUBMISSION_LOAD_SUCCEEDED,
    RESET_SPRAY_EVENTS_FOR_SUBMISSION
} from './constants';

// Local Types
import { SprayEventsForSubmissionState, SprayEventsForSubmissionActions } from './types';

const initialState: SprayEventsForSubmissionState = {};

export default function (
    state: SprayEventsForSubmissionState = initialState,
    action: SprayEventsForSubmissionActions
): SprayEventsForSubmissionState {
    switch (action.type) {
        case SPRAY_EVENTS_FOR_SUBMISSION_LOAD_SUCCEEDED:
            return keyBy(action.payload.data, 'id');
        case RESET_SPRAY_EVENTS_FOR_SUBMISSION:
            return initialState;
        default:
            return state;
    }
}
